import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Style } from 'radium';
import MediaUpload from '../../../../../../components/MediaUpload';
import EditableCaption from '../../../../components/EditableCaption';
import InputButton from '../../../../../../../components/Button/InputButton';

const styles = getStyles(); // eslint-disable-line no-use-before-define
const editorOptions = {
  disableReturn: true,
  toolbar: {
    buttons: [
      'bold',
      'italic',
      'superscript',
      'subscript',
      { name: 'justifyLeft', contentDefault: '<i class="icon-paragraph-left"></i>' },
      { name: 'justifyCenter', contentDefault: '<i class="icon-paragraph-center"></i>' },
      { name: 'justifyRight', contentDefault: '<i class="icon-paragraph-right"></i>' },
      { name: 'anchor', contentDefault: '<i class="icon-link"></i>' }
    ]
  }
};

class MediaUploadSettings extends Component {
  static contextTypes = {
    dispatch: PropTypes.func
  };

  onCaptionChange = itemId => (text) => {
    this.context.dispatch('UPDATE_ITEM_DATA', {
      _id: itemId,
      caption: text
    });
  };

  getImageResizable = (variant) => {
    if (variant === 'hero' || variant === 'textAsideLeft' || variant === 'textAsideRight') {
      return true;
    }
    return false;
  };

  filterInputValue = (value) => {
    const parsedValue = parseInt(value, 10);
    if (!parsedValue) {
      return 1;
    }
    if (parsedValue > 100) {
      return 100;
    }
    if (parsedValue <= 0) {
      return 1;
    }
    return parsedValue;
  };

  newAvatarUploadDone = blockItem => (s3Url, imagePlaceholder) => {
    this.context.dispatch('UPDATE_ITEM_MEDIA', {
      _id: blockItem.items[0]._id,
      avatar: {
        media: {
          image: {
            src: s3Url,
            thumbnail: s3Url,
            placeHolder: imagePlaceholder || '',
            isProcessing: false
          }
        }
      }
    });
  };

  newBackgroundUploadDone = blockItem => (s3Url, imagePlaceholder) => {
    this.context.dispatch('UPDATE_ITEM_MEDIA', {
      _id: blockItem.items[0]._id,
      background: {
        media: {
          image: {
            src: s3Url,
            thumbnail: s3Url,
            placeHolder: imagePlaceholder || '',
            isProcessing: false
          }
        }
      }
    });
  };

  newUploadDone = blockItem => (s3Url, imagePlaceholder) => {
    const { size } = blockItem.items[0].media.image;
    this.context.dispatch('UPDATE_ITEM_MEDIA', {
      _id: blockItem.items[0]._id,
      media: {
        image: {
          src: s3Url,
          thumbnail: s3Url,
          placeHolder: imagePlaceholder || '',
          isProcessing: false,
          size
        }
      }
    });
  };

  changeImageSize = blockItem => (event) => {
    const size = this.filterInputValue(event.target.value);
    const { src, thumbnail, placeHolder, isProcessing } = blockItem.items[0].media.image;
    this.context.dispatch('UPDATE_ITEM_MEDIA', {
      _id: blockItem.items[0]._id,
      media: {
        image: {
          src,
          thumbnail,
          placeHolder,
          isProcessing,
          size
        }
      }
    });
  };

  renderCaption(item) {
    const caption = item.caption;

    return (
      <EditableCaption
        wrapperClassName="block-image__caption brand--body brand--linkColor"
        text={caption}
        placeholder="Add a caption"
        component="figcaption"
        editable={true}
        onChange={this.onCaptionChange(item._id, this.context.dispatch)}
        editorOptions={editorOptions}
      />
    );
  }

  renderMediaUpload = (blockItem) => {
    const family = blockItem.family;
    const variant = blockItem.variant;
    if (family === 'quote' && variant === 'fullBackground') {
      const avatarMediaImage = blockItem.items[0].avatar.media.image.thumbnail;
      const backgroundMediaImage = blockItem.items[0].background.media.image.thumbnail;
      return (
        <div>
          <MediaUpload
            uniqueId="098765"
            src={avatarMediaImage}
            uploadDone={this.newAvatarUploadDone(blockItem)}
          />
          <MediaUpload
            uniqueId="234567"
            src={backgroundMediaImage}
            uploadDone={this.newBackgroundUploadDone(blockItem)}
          />
        </div>
      );
    }
    if (family === 'quote') {
      const avatarMediaImage = blockItem.items[0].avatar.media.image.thumbnail;
      return (
        <MediaUpload
          uniqueId="098765"
          src={avatarMediaImage}
          uploadDone={this.newAvatarUploadDone(blockItem)}
        />
      );
    }
    if (family === 'image') {
      const mediaImage = blockItem.items[0].media.image.src;
      return (
        <MediaUpload
          uniqueId="123456"
          src={mediaImage}
          uploadDone={this.newUploadDone(blockItem)}
        />
      );
    }
    return null;
  };

  renderResizeInput = (blockItem, size) => (
    <div>
      <p className="settings-title">Image size: </p>
      <div className="boxinput-wrapper">
        <InputButton
          buttonProps={{
            text: `${size} %`
          }}
          inputProps={{ defaultText: size.toString(), maxlength: 3, textAlign: 'right' }}
          onInputBlur={this.changeImageSize(blockItem)}
        />
      </div>
    </div>
  );

  render() {
    const { blockItem } = this.props;
    const family = blockItem.family;
    const variant = blockItem.variant;
    const isImageResizable = this.getImageResizable(variant);
    let size = 100;
    if (
      variant === 'hero'
      || variant === 'full'
      || variant === 'textAsideLeft'
      || variant === 'textAsideRight'
      || variant === 'textOverlay'
    ) {
      size = blockItem.items[0].media.image.size;
    }
    return (
      <div className="MediaUploadSettingsContainer">
        {this.renderMediaUpload(blockItem)}
        {family === 'image' && variant !== 'textOverlay' && this.renderCaption(blockItem.items[0])}
        {isImageResizable && this.renderResizeInput(blockItem, size)}
        <Style rules={styles.classBased} scopeSelector=".MediaUploadSettingsContainer" />
      </div>
    );
  }
}

function getStyles() {
  return {
    classBased: {
      '.settings-title': {
        color: 'rgba(49, 53, 55, .4)',
        fontSize: '16px !important',
        display: 'inline-block',
        lineHeight: '28px !important',
        verticalAlign: 'middle'
      },
      '.boxinput-wrapper': {
        width: '50px',
        display: 'inline-block',
        verticalAlign: 'middle',
        marginLeft: '5px',
        lineHeight: '20px'
      }
    }
  };
}

export default MediaUploadSettings;
